import { breakpoints, DropdownMenu, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { Option } from '~/components/filter/Option';

export const StyledDropdownMenu = styled(DropdownMenu)`
  @media ${breakpoints['max-xs']} {
    width: 250px;
    min-width: 250px;
  }
`;

export const PrefixText = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  ${typographyV2.bodySm};
`;

export const StyledOptionWrapper = styled.div<{ $disabled: boolean }>`
  ${({ $disabled }) =>
    $disabled &&
    css`
      ${Option.Styled.ItemDescription} {
        color: var(--text-disabled);
      }
    `}
`;
